import { msalInstance } from "../App";

// Key used to store JWT in localStorage for cross-app authentication
const JWT_STORAGE_KEY = "ai_agent_jwt";

// Helper to store JWT in localStorage
const storeJwtInLocalStorage = (token) => {
  if (token) {
    try {
      localStorage.setItem(JWT_STORAGE_KEY, token);
    } catch (error) {
      console.warn("Failed to store JWT in localStorage:", error);
    }
  }
};

// Helper to clear JWT from localStorage
export const clearJwtFromLocalStorage = () => {
  try {
    localStorage.removeItem(JWT_STORAGE_KEY);
  } catch (error) {
    console.warn("Failed to clear JWT from localStorage:", error);
  }
};

// Helper to get JWT from localStorage (for use by sister apps)
export const getJwtFromLocalStorage = () => {
  try {
    return localStorage.getItem(JWT_STORAGE_KEY);
  } catch (error) {
    console.warn("Failed to get JWT from localStorage:", error);
    return null;
  }
};

export const getIdToken = async () => {
  const accounts = await msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    console.error("No accounts signed in");
    return null;
  }
  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: ["user.read"],
      account: accounts[0],
    });

    // Check if the token is expired or about to expire (within 5 minutes)
    const expiresOn = new Date(response.expiresOn);
    if (expiresOn.getTime() - Date.now() < 300000) {
      // 5 minutes in milliseconds
      return refreshToken();
    }

    // Store JWT in localStorage for cross-app authentication (e.g., champions app)
    storeJwtInLocalStorage(response.idToken);

    return response.idToken;
  } catch (error) {
    console.error("Error acquiring token silently", error);
    return null;
  }
};

export const getAccount = async () => {
  const accounts = await msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    console.error("No accounts signed in");
    return null;
  }
  return accounts[0];
};

export const getUserName = async () => {
  const account = await getAccount();
  return account.username;
};

export const getFirstName = async () => {
  const account = await getAccount();
  const name = account.name;
  return name.indexOf(" ") !== -1 ? name.split(" ")[0] : name;
};

export const getFullName = async () => {
  const account = await getAccount();
  return account.name;
};

export const refreshToken = async () => {
  const accounts = await msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    console.error("No accounts signed in");
    return null;
  }
  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: ["user.read"],
      account: accounts[0],
      forceRefresh: true, // This forces MSAL to get a new token
    });

    // Store refreshed JWT in localStorage for cross-app authentication
    storeJwtInLocalStorage(response.idToken);

    return response.idToken;
  } catch (error) {
    console.error("Error refreshing token", error);
    return null;
  }
};
